import React from "react";
import { X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import TemplateVersions from "./TemplateVersions";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useIsAdmin } from "@/hooks/useIsAdmin";
interface TemplateVersionsModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleSelect: (option: string) => void;
}

const TemplateVersionsModal: React.FC<TemplateVersionsModalProps> = ({
  open,
  setOpen,
  handleSelect,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedVersion = searchParams.get("version");
  const isAdmin = useIsAdmin();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const { templateId = "" } = useParams<{
    templateId: string;
  }>();

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center 
        bg-black bg-opacity-80 dark:bg-opacity-50 backdrop-blur-md  
        transition-opacity duration-300 
        ${open ? "opacity-100 visible" : "opacity-0 invisible"}`}
      onClick={() => {
        navigate(
          `${isAdmin ? "/admin" : ""}/dashboard/templates/${templateId}`,
          { replace: true }
        );
        setOpen(false);
      }}
    >
      <div
        className={`w-full md:w-[80%] h-full md:h-[90vh] border-2 bg-white dark:bg-gray-800 dark:text-white md:rounded-lg transform transition-all duration-300 
          ${open ? "scale-100 opacity-100" : "scale-90 opacity-0"}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-2 mt-2">
          <div className="flex items-center px-2 h-[30px] mb-5">
            {width < 768 && selectedVersion && (
              <button
                onClick={() =>
                  navigate(
                    `${
                      isAdmin ? "/admin" : ""
                    }/dashboard/templates/${templateId}`
                  )
                }
                className="flex items-center gap-2 text-gray-600 dark:text-gray-300"
              >
                <ChevronLeftIcon className="h-5 w-5" />
                <span>Back to Versions</span>
              </button>
            )}
            {((width < 768 && !selectedVersion) || width > 768) && (
              <span className="font-semibold text-xl">Versions</span>
            )}

            <div className="flex items-center gap-4 ml-auto">
              <div
                onClick={() => {
                  setOpen(false);
                }}
                className="cursor-pointer"
              >
                <X
                  size={17}
                  className="text-gray-500 hover:text-gray-600 dark:text-gray-100"
                />
              </div>
            </div>
          </div>
          <TemplateVersions
            modalOpen={open}
            closeModal={() => setOpen(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default TemplateVersionsModal;
